export default __webpack_public_path__ + "static/media/1756.8594e7a9.png";